import React from 'react';
import { AppNotificationsCore, MappedEvents } from './app_notifications_core';
import { ToastNotification, ToastNotificationSpecification } from './toast_notification';
import { ToastNotificaion } from './toast_notification.component';

const appNotificationCore = new AppNotificationsCore<MappedEvents>();
export const AppNotificationsCtx = React.createContext(appNotificationCore);

export function toast(spec: ToastNotificationSpecification): void {
	appNotificationCore.add(new ToastNotification(spec));
}

export function AppNotificationsProvider(props: React.PropsWithChildren): JSX.Element {
	return (
		<>
			<ToastNotificaion />

			{props.children}
		</>
	);
}
